<template>
    <div class="appraisal-detail-component">
        <div class="card">
            <div class="card-header row align-items-center bg-transparent py-0">
                <div class="d-flex justify-content-between" style="align-items: center;">
                    <div>
                        <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                    </div>
                    <div>
                        <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                            <b-dropdown-item @click="showAppraisalFormModal"><i class="fa fa-edit" aria-hidden="true"></i>Edit Info</b-dropdown-item>
                            <b-dropdown-item ><router-link :to="{ name: 'modul-appraisal', params:{ modulId: questionOverview.learning_activity_id} }" class="icon-clicked p-1"><i class="fa fa-arrow-left" aria-hidden="true"></i> Menu Penilaian</router-link></b-dropdown-item>
                        </b-dropdown>   
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="detail px-2">
                    <div class="title">
                        <b-form-input v-model="questionOverview.name" disabled></b-form-input>
                    </div>
                </div>
            </div>
            <hr class="mt-0">
            <div class="card-body">
                <div class="detail px-2">
                    <b-form-group
                        id="duration"
                        label="Durasi"
                    >
                        <b-form-input v-model="questionOverview.duration" disabled></b-form-input>
                        <b-form-text id="input-live-help">Lama Pengerjaan dalam satuan menit.</b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="tanggal-mulai"
                        label="Tanggal Mulai"
                    >
                        <b-form-input v-model="questionOverview.start_date" disabled></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="tanggal-berakhir"
                        label="Tanggal Berakhir"
                    >
                        <b-form-input v-model="questionOverview.end_date" disabled></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <hr class="mt-0">
            <div class="card-body">
                <div class="detail px-2">
                    <!-- <div class="row">
                        <div class="col-lg-6 d-flex justify-content-between">
                            <div>Terbitkan</div>
                            <div>:</div>
                        </div>
                        <div class="col-lg-6">
                            <b-form-radio-group
                                id="tes"
                                name="tes"
                                v-model="questionOverview.is_publish"
                                :options="options"
                                class="mb-3"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                                disabled
                            ></b-form-radio-group>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-lg-6 d-flex justify-content-between">
                            <div>Acak Soal</div>
                            <div>:</div>
                        </div>
                        <div class="col-lg-6">
                            <b-form-radio-group
                                id="tes1"
                                name="tes1"
                                v-model="questionOverview.is_random_soal"
                                :options="options"
                                class="mb-3"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                                disabled
                            ></b-form-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 d-flex justify-content-between">
                            <div>Acak Pilihan</div>
                            <div>:</div>
                        </div>
                        <div class="col-lg-6">
                            <b-form-radio-group
                                id="tes2"
                                name="tes2"
                                v-model="questionOverview.is_random_opsi"
                                :options="options"
                                class="mb-3"
                                value-field="item"
                                text-field="name"
                                disabled-field="notEnabled"
                                disabled
                            ></b-form-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<b-modal
			ref="appraisal-form-modal"
			class="appraisal-form-modal"
			size="lg"
            title="Tambah Penilaian"
            @show="resetAppraisalForm"
            @hidden="resetAppraisalForm"
			hide-footer
			no-close-on-backdrop
		>
            <appraisal-form
                :modulId="modulId"
                :appraisalType="appraisalType"
                :appraisalId="questionOverview.id"
                :appraisalDetail="questionOverview"
            ></appraisal-form>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
	import AppraisalForm from "./AppraisalForm";
    export default {
        props: {
            quizId: {
                type: String,
                default: null
            },
            appraisalType: {
                type: Array,
                default: null
            },
        },
        components: {
            AppraisalForm
        },
        data() {
            return {
                modulId: this.$route.params.modulId,
                options: [
                    { item: '1', name: 'Ya' },
                    { item: '0', name: 'Tidak' },
                ]
            }
        },
        computed: {
            ...mapGetters({
                questionOverview: 'getQuestionOverview',
            })
        },
        methods: {
            hideDetail() {
                EventBus.$emit('hideDetail', true)
            },
            editInfo() {
                console.log("edit info");
            },
            showAppraisalFormModal() {
                this.$refs['appraisal-form-modal'].show()
            },
            hideAppraisalFormModal() {
                this.$refs['appraisal-form-modal'].hide()
                this.resetAppraisalForm()
            },
            resetAppraisalForm() {
                EventBus.$emit('resetAppraisalForm', true)
            },
        },
        async created() {
			EventBus.$on('hideAppraisalFormModal', (val) => {
				if (val) {
					this.hideAppraisalFormModal()
				}
			})
        }
    }
</script>